const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const APIData = {
    "SHOP": process.env.REACT_APP_SHOPAPI_URL, // SHOP
    "USER": process.env.REACT_APP_USERAPI_URL, // USER
    "REALTIME": process.env.REACT_APP_REALTIMEAPI_URL, // REALTIME
    "MEDIA":process.env.REACT_APP_MEDIAAPI_URL, // MEDIA
    "LOGS": process.env.REACT_APP_LOGAPI_URL, // LOGS
    "MEDIA_TYPES" : 
        {
            PRODUCTS: "products", 
            CATEGORIES: "categories",
            BACKGROUNDS: "backgrounds", 
            HEADERS: "headers", 
            ICONS: "icons"
        }
}
// export const APIData = {
//     "SHOP": "https://shop.viveel.de", // SHOP
//     "USER": "https://user.viveel.de", // USER
//     "REALTIME": "https://realtime.viveel.de", // REALTIME
//     "MEDIA": "https://media.viveel.de", // MEDIA
//     "LOGS": "https://logs.viveel.de", // LOGS
//     "MEDIA_TYPES" : 
//         {
//             PRODUCTS: "products", 
//             CATEGORIES: "categories",
//             BACKGROUNDS: "backgrounds", 
//             HEADERS: "headers", 
//             ICONS: "icons"
//         }
// }